export default "__VITE_ASSET__DczM1LvV__"